import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeContextProvider } from "./context/ThemeContext"; // Adjust the path as needed
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import './index.css'
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeContextProvider>
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>

      <App />
      </LocalizationProvider>
      </SnackbarProvider>
    </ThemeContextProvider>
  </React.StrictMode>
);

reportWebVitals();
